import React from 'react';
import { Route } from 'react-router-dom';
import FirstStart from '.';

const paths = {
  firstStart: '/first-start',
};

export default [
  <Route exact path={paths.firstStart} component={() => <FirstStart />} key={paths.firstStart} />,
];
